import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(a, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.788 1.052a1 1 0 0 1 .632 1.265l-.212.635a10 10 0 0 1 3.778-.74c5.515 0 9.985 4.47 9.985 9.986a9.95 9.95 0 0 1-2.336 6.42 1 1 0 1 1-1.532-1.287q.156-.186.3-.38a7.986 7.986 0 0 0-9.46-12.139l.8.226A1 1 0 0 1 9.2 6.962L6.151 6.1a1 1 0 0 1-.676-1.28l1.048-3.137a1 1 0 0 1 1.265-.631m7.423 9.069a1 1 0 0 0-1.744-.981l-1.638 2.913H8.563a1 1 0 1 0 0 2h3.833q.05.002.103-.003a1 1 0 0 0 .797-.526zM4 12.198a1 1 0 0 0-2 0c0 5.515 4.47 9.985 9.986 9.985a10 10 0 0 0 3.328-.568 1 1 0 0 0-.666-1.886 7.9 7.9 0 0 1-2.662.454A7.986 7.986 0 0 1 4 12.198",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: n };
export {
  d as default,
  n as render
};
//# sourceMappingURL=ic_history-DQe2YW9q.js.map
